import React, { useEffect, useRef, useState } from "react";

import axios from "axios";
import { config } from "../config";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
  PaginationOptions,
  useDatatableWrapper,
} from "react-bs-datatable";
import { Col, Row, Table, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "bootstrap/dist/css/bootstrap.min.css";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  faCheck,
  faPen,
  faPenAlt,
  faPrint, faFilter,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import ShareWhatsapp from "../helpers/shareWhatsapp";
import DonationbillPrint from "./donationbillprint";
import CustomModal from "../components/modal";
import TaxBillPrint from "./taxbillprint";
import TaxBillPrintThermal from "./taxbillprintthermal";
import TranslateToTamil from "../helpers/wordtotamil";

function KumbaTaxlist() {
  const [donorlist, setDonorlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCity, setSelectedCity] = useState('');
  const [showMobileOptions, setShowMobileOptions] = useState(false);
  const [startPrint, setStartPrint] = useState(false);
  const [printType, setPrintType] = useState(() => localStorage.getItem('preferredPrintType') || 'A4');
  const [enableEdit, setEnableEdit] = useState(false);
  const [PrintData, setPrintData] = useState({
    receipt_no: "",
    address: "",
    amount: "",
    amount_in_words: "",
    mobile: "",
    name: "",
    receiver: "",
    date: "",
  });

  const [editData, setEditData] = useState({
    user_id: 0,
    name: "",
    address: "",
    mobile: "",
  });

  const nameRef = useRef();
  const addressRef = useRef();
  const mobileRef = useRef();

  const FetchData = async () => {
    try {
      setLoading(true);
      const data = await axios.get(`${config.BACKENDURL}getAllKumbaTaxList.php?festival_type=Kumbaabishegam`);
      if (data.data.status === 200) {
        setDonorlist(data.data.data);
      }
    } catch (error) {
      console.error("Error fetching kumba tax list:", error);
    } finally {
      setLoading(false);
    }
  };

  const HandlePrintData = (values) => {
    setPrintData({
      ...PrintData,
      address: values.address,
      amount: values.amount,
      amount_in_words: values.amount_in_word,
      mobile: values.mobile,
      name: values.name,
      receipt_no: values.receipt_no,
      date: values.receipt_date.replaceAll("/", "-"),
      receiver: values.receiver_name,
    });
    setStartPrint(true);
  };

  const HandleEdit = (values) => {
    console.log("values", values);
    setEditData({
      ...editData,
      user_id: values.user_id,
      name: values.name,
      mobile: values.mobile,
      address: values.address,
    });
    setEnableEdit(true);
  };

  const HandleEditSubmit = async (e) => {
    e.preventDefault();
    const insert = await axios.post(`${config.BACKENDURL}updateUserdata.php`, {
      user_id: editData.user_id,
      name: e.target.name.value,
      address: e.target.address.value,
      mobile: e.target.mobile.value,
    });
    if (insert.data.status === 200) {
      alert("புதுப்பிக்கப்பட்டது");
      window.location.reload();
    }
  };

  const header = [
    { title: "SI No", prop: "id" },
    { title: "Year", prop: "receipt_year", isSortable: true },
    { title: "Receipt no", prop: "receipt_no" },
    { title: "Name", prop: "name", isFilterable: true },
    { title: "Address", prop: "address", isFilterable: true },
    { title: "Mobile", prop: "mobile", isFilterable: true },
    { title: "Paid", prop: "amount" },
    { title: "Date", prop: "receipt_date" },
    { title: "Received by", prop: "receiver_name", isFilterable: true },
    { title: "Festival", prop: "festival_type", isFilterable: true },
    {
      title: "Share",
      prop: "button",
      cell: (row) => (
        <button
          className="btn btn-md border border-0 "
          onClick={() => {
            ShareWhatsapp(
              row.receipt_no,
              row.name,
              row.address,
              row.mobile,
              row.amount,
              row.amount_in_word,
              row.receipt_date,
              "KUMBAABISHEGAM TAX",
              "கும்பாபிஷேகம் வரி"
            );
          }}
        >
          <FontAwesomeIcon
            size="xl"
            className="text-success"
            icon={faWhatsapp}
          />
        </button>
      ),
    },
    {
      title: "Print",
      prop: "button",
      cell: (row) => (
        <button
          className="btn btn-md border border-0 "
          onClick={() => {
            HandlePrintData(row);
          }}
        >
          <FontAwesomeIcon size="lg" className="text-info" icon={faPrint, faFilter} />
        </button>
      ),
    },
    {
      title: "Actions",
      prop: "button",
      cell: (row) => (
        <div className="d-flex">
          <button
            className="btn btn-md border border-0 "
            onClick={() => {
              HandleEdit(row);
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="text-primary"
              icon={faPenAlt}
            />
          </button>
          {/* <button
            className="btn btn-md border border-0 "
            onClick={() => {
              console.log("row", row);
            }}
          >
            <FontAwesomeIcon size="lg" className="text-danger" icon={faTrash} />
          </button> */}
        </div>
      ),
    },
  ];
  useEffect(() => {
    FetchData();
  }, []);

  function MobileCardList() {
    // data is already filtered+paginated by DatatableWrapper context
    const { data } = useDatatableWrapper();
    const rows = data || [];
    return (
      <div className="d-md-none mt-3">
        {rows.map((row, idx) => (
          <div key={idx} style={{
            background: '#ffffff',
            borderRadius: '14px',
            border: '1px solid #dee2e6',
            padding: '14px 16px',
            marginBottom: '14px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
            color: '#212529',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
              <span style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1a1a2e', flex: 1, paddingRight: 8 }}>{row.name}</span>
              <span style={{ fontWeight: 800, fontSize: '1.15rem', color: '#198754', whiteSpace: 'nowrap' }}>₹ {row.amount}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.82rem', color: '#6c757d', marginBottom: '4px' }}>
              <span>Receipt: #{row.receipt_no}</span>
              <span>{row.receipt_date}</span>
            </div>
            <div style={{ fontSize: '0.9rem', color: '#495057', marginBottom: '4px' }}>📱 {row.mobile}</div>
            <div style={{ fontSize: '0.82rem', color: '#6c757d', paddingBottom: '10px', borderBottom: '1px solid #e9ecef', marginBottom: '10px' }}>
              {row.address}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <button className="btn btn-light border" style={{ borderRadius: '50%', width: 44, height: 44, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => ShareWhatsapp(row.receipt_no, row.name, row.address, row.mobile, row.amount, row.amount_in_word, row.receipt_date, "KUMBAABISHEGAM TAX", "கும்பாபிஷேகம் வரி")}>
                <FontAwesomeIcon icon={faWhatsapp} className="text-success" size="lg" />
              </button>
              <button className="btn btn-light border" style={{ borderRadius: '50%', width: 44, height: 44, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => HandlePrintData(row)}>
                <FontAwesomeIcon icon={faPrint, faFilter} className="text-info" size="lg" />
              </button>
              <button className="btn btn-light border" style={{ borderRadius: '50%', width: 44, height: 44, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => HandleEdit(row)}>
                <FontAwesomeIcon icon={faPenAlt} className="text-primary" size="lg" />
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const uniqueCities = [...new Set(donorlist.map(item => item.address))].filter(Boolean).sort();
  const filteredDonorList = selectedCity ? donorlist.filter(item => item.address === selectedCity) : donorlist;

  return (
    <div className="container-fluid p-1 p-md-5">
      <div className="glass-panel p-2 p-md-4">
        <h2 className="text-center py-1 py-md-3 mb-2 mb-md-4 text-warning fw-bold border-bottom border-secondary fs-5 fs-md-2">
          வரி செலுத்தியவர்களின் பட்டியல்
        </h2>
                <div className="d-md-none text-end mb-2">
          <button className="btn btn-sm bg-white shadow-sm text-dark border-secondary" style={{ color: "black", fontWeight: "600" }} onClick={() => setShowMobileOptions(!showMobileOptions)}>
            <FontAwesomeIcon icon={faFilter} /> {showMobileOptions ? "Hide Options" : "Show Options"}
          </button>
        </div>
        <div className={`flex-wrap justify-content-center justify-content-md-end mb-2 gap-1 mb-md-3 d-md-flex ${showMobileOptions ? 'd-flex' : 'd-none'}`}>
          <div className="form-check form-check-inline bg-white px-2 py-1 rounded shadow-sm">
            <input autoComplete="off" className="form-check-input ms-0 me-2" type="radio" name="printTypeList" id="printA4List" value="A4" checked={printType === 'A4'} onChange={() => { setPrintType('A4'); localStorage.setItem('preferredPrintType', 'A4'); }} />
            <label className="form-check-label fw-bold text-dark" htmlFor="printA4List">A4 Print</label>
          </div>
          <div className="form-check form-check-inline bg-white px-2 py-1 rounded shadow-sm">
            <input autoComplete="off" className="form-check-input ms-0 me-2" type="radio" name="printTypeList" id="printThermalList" value="Thermal" checked={printType === 'Thermal'} onChange={() => { setPrintType('Thermal'); localStorage.setItem('preferredPrintType', 'Thermal'); }} />
            <label className="form-check-label fw-bold text-dark" htmlFor="printThermalList">Thermal Print</label>
          </div>
        </div>
        {loading ? (
          <div className="text-center py-5 my-4">
            <Spinner animation="border" variant="warning" role="status" style={{ width: "3.5rem", height: "3.5rem", borderWidth: "4px" }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <div className="mt-3 text-warning fw-bold fs-5">பட்டியல் ஏற்றப்படுகிறது...</div>
            <div className="text-light opacity-75 small">தகவல்கள் பதிவேற்றப்படுகிறது, காத்திருக்கவும்...</div>
          </div>
        ) : (
          <DatatableWrapper
            body={filteredDonorList}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15, 20, 50, 100],
              },
            }}
          >
            <Row className="mb-2 g-2 align-items-center">
              <Col xs={12} md={4} className={`flex-row justify-content-between justify-content-md-start gap-2 w-100 d-md-flex ${showMobileOptions ? 'd-flex' : 'd-none'}`}>
                <div style={{ flex: 1 }}>
                  <Filter classes={{input: "form-control-sm"}} />
                </div>
                <div style={{ flex: 1 }}>
                  <select 
                    className="form-select form-select-sm w-100" 
                    value={selectedCity} 
                    onChange={(e) => setSelectedCity(e.target.value)}
                  >
                    <option value="">All Cities</option>
                    {uniqueCities.map((city, idx) => (
                      <option key={idx} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
              </Col>
              <Col xs={12} md={4} className="d-none d-md-flex justify-content-center">
                <PaginationOptions alwaysShowPagination />
              </Col>
              <Col xs={12} md={4} className="d-flex justify-content-center justify-content-md-end mt-1 mt-md-0">
                <Pagination alwaysShowPagination paginationRange={1} classes={{buttonGroup: "pagination-sm m-0"}} />
              </Col>
            </Row>

            {/* Desktop Table View */}
            <div className="table-responsive mt-4 d-none d-md-block">
              <Table striped hover variant="dark" className="bg-transparent align-middle">
                <TableHeader />
                <TableBody />
              </Table>
            </div>

            {/* Mobile Card View - uses DatatableWrapper context for pagination/filter */}
            <MobileCardList />
          </DatatableWrapper>
        )}
      </div>
        {console.log("PrintData", PrintData)}
        {startPrint && printType === 'A4' && (
          <TaxBillPrint
            receiptno={PrintData.receipt_no}
            address={PrintData.address}
            amount={PrintData.amount}
            AfterPrintClose={() => {
              setPrintData({
                receipt_no: "",
                address: "",
                amount: "",
                amount_in_words: "",
                mobile: "",
                name: "",
                receiver: "",
              });
              setStartPrint(false);
            }}
            date={PrintData.date}
            amount_in_words={PrintData.amount_in_words}
            mobile={PrintData.mobile}
            name={PrintData.name}
            receiver={PrintData.receiver}
            festival_type="Kumbaabishegam"
          />
        )}
        {startPrint && printType === 'Thermal' && (
          <TaxBillPrintThermal
            receiptno={PrintData.receipt_no}
            address={PrintData.address}
            amount={PrintData.amount}
            AfterPrintClose={() => {
              setPrintData({
                receipt_no: "",
                address: "",
                amount: "",
                amount_in_words: "",
                mobile: "",
                name: "",
                receiver: "",
              });
              setStartPrint(false);
            }}
            date={PrintData.date}
            amount_in_words={PrintData.amount_in_words}
            mobile={PrintData.mobile}
            name={PrintData.name}
            receiver={PrintData.receiver}
            festival_type="Kumbaabishegam"
          />
        )}

        {/* Edit modal */}
        <CustomModal
          show={enableEdit}
          bodyContent={
            <div style={{ minWidth: "40vw" }}>
              <form autoComplete="off" onSubmit={(e) => HandleEditSubmit(e)}>
                <div className="mb-3">
                  <label>பெயர்</label>
                  <input autoComplete="off"
                    defaultValue={editData.name}
                    ref={nameRef}
                    name="name"
                    required
                    className="form-control"
                    onBlur={async (e) => {
                      const tamil = await TranslateToTamil(e.target.value);
                      if (tamil) {
                        nameRef.current.value = tamil;
                      }
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label>முகவரி</label>
                  <input autoComplete="off"
                    defaultValue={editData.address}
                    ref={addressRef}
                    required
                    name="address"
                    className="form-control"
                    onBlur={async (e) => {
                      const tamil = await TranslateToTamil(e.target.value);
                      if (tamil) {
                        addressRef.current.value = tamil;
                      }
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label>கைபேசி</label>
                  <input autoComplete="off"
                    defaultValue={editData.mobile}
                    minLength={15}
                    ref={mobileRef}
                    required
                    name="mobile"
                    className="form-control"
                    onBlur={async (e) => {
                      const tamil = await TranslateToTamil(e.target.value);
                      if (tamil) {
                        mobileRef.current.value = tamil;
                      }
                    }}
                  />
                </div>
                <div className="text-center">
                  <button className="btn btn-sm btn-success">
                    சமர்ப்பிக்க <FontAwesomeIcon icon={faCheck} />
                  </button>
                </div>
              </form>
            </div>
          }
          onClose={() => {
            setEditData({
              user_id: 0,
              name: "",
              address: "",
              mobile: "",
            });
            setEnableEdit(false);
          }}
        />
    </div>
  );
}

export default KumbaTaxlist;
